import { render, staticRenderFns } from "./sand_15.vue?vue&type=template&id=d3c0bdbe&scoped=true&"
import script from "./sand_15.vue?vue&type=script&lang=js&"
export * from "./sand_15.vue?vue&type=script&lang=js&"
import style0 from "./sand_15.vue?vue&type=style&index=0&id=d3c0bdbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c0bdbe",
  null
  
)

export default component.exports